import React, { useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { annoncesAPI, isLoggedIn, uploadAPI } from '../api';
import '../App.css';

const marques = ['Toyota','Mercedes-Benz','Peugeot','Renault','Ford','Honda','Nissan','Hyundai','Kia','Mitsubishi','Isuzu','Volvo','MAN','Scania','DAF','Yamaha','Kawasaki','Suzuki','Caterpillar','Komatsu','Autre'];
const categories = ['Moteur','Freinage','Suspension','Transmission','Electrique','Carrosserie','Refroidissement','Echappement','Hydraulique','Pneumatique','Filtration','Autre'];
const villes = ['Dakar','Thies','Saint-Louis','Kaolack','Ziguinchor','Touba','Mbour','Rufisque','Abidjan','Bamako','Conakry','Lome','Cotonou','Autre'];
const mobileMoneys = ['Wave','Orange Money','Free Money','Expresso'];

function AnnoncePage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [apiError, setApiError] = useState('');
  const [photos, setPhotos] = useState([]);
  const photosRef = useRef([]);
  const [compatList, setCompatList] = useState([{ modele: '', debut: '', fin: '' }]);
  const [villesSelected, setVillesSelected] = useState([]);
  const [customVille, setCustomVille] = useState('');
  const [garantieOn, setGarantieOn] = useState(false);
  const [garantieDuree, setGarantieDuree] = useState('6 mois');

  const [form, setForm] = useState({
    typeVehicule: 'Automobile',
    marqueVehicule: '',
    anneeVehicule: '',
    nomPiece: '',
    marquePiece: '',
    reference: '',
    categorie: '',
    typePiece: 'Originale OEM',
    etat: 'Neuf',
    description: '',
    prix: '',
    negociable: 'Non',
    quantite: '1',
    delaiExped: 'Sous 24h',
    mobileMoney: '',
  });

  const upd = (key, val) => setForm(prev => ({ ...prev, [key]: val }));
  const years = Array.from({ length: 36 }, (_, i) => 2025 - i);

  const validate = () => {
    const e = {};
    if (step === 1) {
      if (!form.marqueVehicule) e.marqueVehicule = 'Requis';
      if (!form.anneeVehicule) e.anneeVehicule = 'Requis';
      if (!form.nomPiece) e.nomPiece = 'Requis';
      if (!form.marquePiece) e.marquePiece = 'Requis';
      if (!form.categorie) e.categorie = 'Requis';
    }
    if (step === 4) {
      if (!form.prix) e.prix = 'Requis';
      if (!form.quantite) e.quantite = 'Requis';
      if (villesSelected.length === 0) e.villes = 'Selectionnez au moins une ville';
      if (!form.mobileMoney) e.mobileMoney = 'Requis';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const nextStep = () => {
    if (!validate()) return;
    setStep(s => s + 1);
    window.scrollTo(0, 0);
  };

  const prevStep = () => {
    setStep(s => s - 1);
    window.scrollTo(0, 0);
  };

  const handlePhotos = async (files) => {
    const fileArray = Array.from(files).slice(0, 8 - photosRef.current.length);
    setUploadingPhotos(true);
    for (const f of fileArray) {
      await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = async (e) => {
          try {
            const res = await uploadAPI.single(e.target.result);
            const photoUrl = res.data?.url || res.data?.secure_url;
            if (photoUrl) {
              photosRef.current = [...photosRef.current, photoUrl];
              setPhotos([...photosRef.current]);
            }
          } catch (err) {
            console.error('Erreur upload photo:', err);
          }
          resolve();
        };
        reader.readAsDataURL(f);
      });
    }
    setUploadingPhotos(false);
  };

  const toggleVille = (v) => {
    setVillesSelected(prev => prev.includes(v) ? prev.filter(x => x !== v) : [...prev, v]);
  };

  const addVille = () => {
    if (!customVille.trim()) return;
    if (!villesSelected.includes(customVille)) setVillesSelected(prev => [...prev, customVille]);
    setCustomVille('');
  };

  const addCompat = () => setCompatList(prev => [...prev, { modele: '', debut: '', fin: '' }]);
  const removeCompat = (i) => { if (compatList.length > 1) setCompatList(prev => prev.filter((_, idx) => idx !== i)); };
  const updCompat = (i, key, val) => setCompatList(prev => prev.map((c, idx) => idx === i ? { ...c, [key]: val } : c));

  const publish = async () => {
    if (!isLoggedIn()) { navigate('/connexion'); return; }
    setLoading(true);
    setApiError('');
    try {
      const data = {
        type_vehicule: form.typeVehicule,
        marque_vehicule: form.marqueVehicule,
        annee_vehicule: form.anneeVehicule,
        nom_piece: form.nomPiece,
        marque_piece: form.marquePiece,
        reference: form.reference,
        categorie: form.categorie,
        type_piece: form.typePiece,
        etat: form.etat,
        garantie: garantieOn,
        garantie_duree: garantieOn ? garantieDuree : null,
        description: form.description,
        prix: parseInt(form.prix),
        negociable: form.negociable,
        quantite: parseInt(form.quantite),
        delai_expedition: form.delaiExped,
        villes: villesSelected,
        compatibilite: compatList.filter(c => c.modele),
        photos: photosRef.current,
      };
      console.log('Photos envoyées:', photosRef.current);
      await annoncesAPI.create(data);
      navigate('/vendeur');
    } catch (err) {
      setApiError(err.response?.data?.message || 'Erreur lors de la publication');
      if (err.response?.status === 401) navigate('/connexion');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = (err) => ({
    width: '100%', padding: '11px 14px',
    background: err ? 'rgba(239,68,68,.08)' : '#141414',
    border: `1.5px solid ${err ? '#EF4444' : '#333'}`,
    borderRadius: '9px', fontSize: '14px',
    fontFamily: 'Plus Jakarta Sans, sans-serif', color: '#fff', outline: 'none',
  });

  const labelStyle = { fontSize: '11px', fontWeight: '700', color: '#888', letterSpacing: '.4px', display: 'block', marginBottom: '6px' };
  const errStyle = { fontSize: '11px', color: '#EF4444', fontWeight: '700', marginTop: '4px' };
  const cardStyle = { background: '#1C1C1C', border: '1px solid #333', borderRadius: '14px', padding: '24px 28px', marginBottom: '18px' };
  const cardTitleStyle = { fontFamily: 'Bebas Neue, sans-serif', fontSize: '18px', letterSpacing: '1px', color: '#fff', marginBottom: '18px', display: 'flex', alignItems: 'center', gap: '10px' };

  const radioCard = (label, current, val, onSelect, emoji = '') => (
    <div key={val} onClick={() => onSelect(val)} style={{ flex: '1', minWidth: '120px', border: `1.5px solid ${current === val ? '#F5620A' : '#333'}`, borderRadius: '9px', padding: '11px 14px', cursor: 'pointer', background: current === val ? 'rgba(245,98,10,.1)' : '#141414', display: 'flex', alignItems: 'center', gap: '8px' }}>
      {emoji && <span style={{ fontSize: '16px' }}>{emoji}</span>}
      <div style={{ width: '16px', height: '16px', borderRadius: '50%', border: `2px solid ${current === val ? '#F5620A' : '#333'}`, background: current === val ? '#F5620A' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        {current === val && <div style={{ width: '6px', height: '6px', background: '#fff', borderRadius: '50%' }}></div>}
      </div>
      <span style={{ fontSize: '13px', fontWeight: '700', color: current === val ? '#F5620A' : '#888' }}>{label}</span>
    </div>
  );

  const steps = ['Vehicule & piece', 'Etat & garantie', 'Compatibilite', 'Prix & dispo', 'Photos'];

  return (
    <div className="app" style={{ minHeight: '100vh' }}>
      <nav className="nav">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div className="logo-wrap">
            <div className="logo">Tek<span>Teck</span></div>
            <div className="logo-tag">rak tak!</div>
          </div>
        </Link>
        <div style={{ fontSize: '13px', color: '#888' }}>Deposer une annonce</div>
        <Link to="/vendeur"><button className="btn-ghost">← Tableau de bord</button></Link>
      </nav>

      <div style={{ maxWidth: '780px', margin: '0 auto', padding: '28px 24px 100px' }}>
        <div style={{ marginBottom: '24px' }}>
          <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '28px', letterSpacing: '1px', color: '#fff', marginBottom: '4px' }}>DEPOSER UNE ANNONCE</div>
          <div style={{ fontSize: '13px', color: '#888' }}>Renseignez tous les champs pour que votre piece soit bien referencee.</div>
        </div>

        {apiError && (
          <div style={{ background: 'rgba(239,68,68,.12)', border: '1.5px solid rgba(239,68,68,.3)', borderRadius: '10px', padding: '14px 18px', marginBottom: '20px', fontSize: '13px', fontWeight: '700', color: '#EF4444' }}>
            ❌ {apiError}
          </div>
        )}

        {/* PROGRESS */}
        <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '10px', overflow: 'hidden', display: 'flex', marginBottom: '28px' }}>
          {steps.map((s, i) => (
            <div key={i} style={{ flex: 1, padding: '12px 10px', display: 'flex', alignItems: 'center', gap: '8px', borderRight: i < steps.length - 1 ? '1px solid #2A2A2A' : 'none', background: step === i + 1 ? '#F5620A' : step > i + 1 ? 'rgba(245,98,10,.12)' : 'transparent', cursor: step > i + 1 ? 'pointer' : 'default' }} onClick={() => step > i + 1 && setStep(i + 1)}>
              <div style={{ width: '24px', height: '24px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '800', flexShrink: 0, background: step === i + 1 ? 'rgba(255,255,255,.2)' : step > i + 1 ? '#F5620A' : '#141414', color: step >= i + 1 ? '#fff' : '#888', border: step < i + 1 ? '1.5px solid #333' : 'none' }}>
                {step > i + 1 ? '✓' : i + 1}
              </div>
              <div style={{ fontSize: '11px', fontWeight: '700', color: step === i + 1 ? '#fff' : step > i + 1 ? '#F5620A' : '#888', lineHeight: '1.2' }}>{s}</div>
            </div>
          ))}
        </div>

        {/* ETAPE 1 */}
        {step === 1 && (
          <>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>🚗</span> Type de vehicule</div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {[['Automobile','🚗'],['Camion','🚚'],['Moto','🏍️'],['Machine','⚙️']].map(([v, e]) => radioCard(v, form.typeVehicule, v, val => upd('typeVehicule', val), e))}
              </div>
            </div>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>🔧</span> Informations sur la piece</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={labelStyle}>Marque du vehicule ★</label>
                  <select value={form.marqueVehicule} onChange={e => upd('marqueVehicule', e.target.value)} style={inputStyle(errors.marqueVehicule)}>
                    <option value="">Selectionner...</option>
                    {marques.map(m => <option key={m}>{m}</option>)}
                  </select>
                  {errors.marqueVehicule && <div style={errStyle}>{errors.marqueVehicule}</div>}
                </div>
                <div>
                  <label style={labelStyle}>Annee du vehicule ★</label>
                  <select value={form.anneeVehicule} onChange={e => upd('anneeVehicule', e.target.value)} style={inputStyle(errors.anneeVehicule)}>
                    <option value="">Selectionner...</option>
                    {years.map(y => <option key={y}>{y}</option>)}
                  </select>
                  {errors.anneeVehicule && <div style={errStyle}>{errors.anneeVehicule}</div>}
                </div>
                <div>
                  <label style={labelStyle}>Nom de la piece ★</label>
                  <input value={form.nomPiece} onChange={e => upd('nomPiece', e.target.value)} placeholder="Ex : Alternateur..." style={inputStyle(errors.nomPiece)} />
                  {errors.nomPiece && <div style={errStyle}>{errors.nomPiece}</div>}
                </div>
                <div>
                  <label style={labelStyle}>Marque de la piece ★</label>
                  <input value={form.marquePiece} onChange={e => upd('marquePiece', e.target.value)} placeholder="Ex : Bosch, Valeo..." style={inputStyle(errors.marquePiece)} />
                  {errors.marquePiece && <div style={errStyle}>{errors.marquePiece}</div>}
                </div>
                <div>
                  <label style={labelStyle}>Reference / OEM</label>
                  <input value={form.reference} onChange={e => upd('reference', e.target.value)} placeholder="Ex : 0123456789" style={inputStyle()} />
                </div>
                <div>
                  <label style={labelStyle}>Categorie ★</label>
                  <select value={form.categorie} onChange={e => upd('categorie', e.target.value)} style={inputStyle(errors.categorie)}>
                    <option value="">Selectionner...</option>
                    {categories.map(c => <option key={c}>{c}</option>)}
                  </select>
                  {errors.categorie && <div style={errStyle}>{errors.categorie}</div>}
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={labelStyle}>Description</label>
                  <textarea value={form.description} onChange={e => upd('description', e.target.value)} placeholder="Decrivez la piece..." style={{ ...inputStyle(), resize: 'vertical', minHeight: '90px' }} />
                </div>
              </div>
            </div>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>🏷️</span> Type de piece ★</div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {['Originale OEM','Remplacement aftermarket','Reconditionnee'].map(v => radioCard(v, form.typePiece, v, val => upd('typePiece', val)))}
              </div>
            </div>
          </>
        )}

        {/* ETAPE 2 */}
        {step === 2 && (
          <>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>✅</span> Etat de la piece ★</div>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {[['Neuf','🟢'],['Occasion — Tres bon etat','🔵'],['Occasion — Bon etat','🟡'],['Occasion — Etat correct','🟠']].map(([v, e]) => radioCard(v, form.etat, v, val => upd('etat', val), e))}
              </div>
            </div>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>🛡️</span> Garantie</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
                <div onClick={() => setGarantieOn(!garantieOn)} style={{ position: 'relative', width: '44px', height: '24px', cursor: 'pointer' }}>
                  <div style={{ position: 'absolute', inset: 0, background: garantieOn ? '#F5620A' : '#333', borderRadius: '12px', transition: 'background .3s' }}></div>
                  <div style={{ position: 'absolute', top: '3px', left: garantieOn ? '23px' : '3px', width: '18px', height: '18px', background: '#fff', borderRadius: '50%', transition: 'left .3s' }}></div>
                </div>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#fff' }}>{garantieOn ? 'Avec garantie' : 'Pas de garantie'}</span>
              </div>
              {garantieOn && (
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {['1 mois','3 mois','6 mois','12 mois','24 mois'].map(d => (
                    <button key={d} onClick={() => setGarantieDuree(d)} style={{ padding: '8px 16px', border: `1.5px solid ${garantieDuree === d ? '#F5620A' : '#333'}`, borderRadius: '20px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', background: garantieDuree === d ? '#F5620A' : '#141414', color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                      {d}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </>
        )}

        {/* ETAPE 3 */}
        {step === 3 && (
          <div style={cardStyle}>
            <div style={cardTitleStyle}><span>🔗</span> Compatibilite vehicule</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 36px', gap: '8px', marginBottom: '8px' }}>
              {['MODELE','ANNEE DEBUT','ANNEE FIN',''].map((h, i) => <span key={i} style={{ fontSize: '10px', fontWeight: '700', color: '#888' }}>{h}</span>)}
            </div>
            {compatList.map((c, i) => (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 36px', gap: '8px', marginBottom: '8px' }}>
                <input value={c.modele} onChange={e => updCompat(i, 'modele', e.target.value)} placeholder="Ex : Clio IV..." style={inputStyle()} />
                <select value={c.debut} onChange={e => updCompat(i, 'debut', e.target.value)} style={inputStyle()}>
                  <option value="">Depuis...</option>
                  {years.map(y => <option key={y}>{y}</option>)}
                </select>
                <select value={c.fin} onChange={e => updCompat(i, 'fin', e.target.value)} style={inputStyle()}>
                  <option value="">Jusqu'a...</option>
                  {years.map(y => <option key={y}>{y}</option>)}
                </select>
                <button onClick={() => removeCompat(i)} style={{ width: '36px', height: '42px', border: '1.5px solid #EF4444', borderRadius: '8px', background: 'transparent', cursor: 'pointer', color: '#EF4444', fontSize: '18px' }}>×</button>
              </div>
            ))}
            <button onClick={addCompat} style={{ width: '100%', padding: '11px', border: '1.5px dashed #333', borderRadius: '9px', background: 'transparent', color: '#888', fontSize: '13px', fontWeight: '700', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', marginTop: '8px' }}>
              + Ajouter un modele compatible
            </button>
          </div>
        )}

        {/* ETAPE 4 */}
        {step === 4 && (
          <>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>💰</span> Prix & disponibilite</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={labelStyle}>Prix de vente ★</label>
                  <div style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: '14px', top: '50%', transform: 'translateY(-50%)', fontSize: '12px', fontWeight: '700', color: '#888' }}>FCFA</span>
                    <input type="number" value={form.prix} onChange={e => upd('prix', e.target.value)} placeholder="Ex : 45000" style={{ ...inputStyle(errors.prix), paddingLeft: '56px' }} />
                  </div>
                  {errors.prix && <div style={errStyle}>{errors.prix}</div>}
                </div>
                <div>
                  <label style={labelStyle}>Negociable ?</label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    {['Non','Oui'].map(v => radioCard(v, form.negociable, v, val => upd('negociable', val)))}
                  </div>
                </div>
                <div>
                  <label style={labelStyle}>Quantite ★</label>
                  <input type="number" value={form.quantite} onChange={e => upd('quantite', e.target.value)} min="1" style={inputStyle(errors.quantite)} />
                  {errors.quantite && <div style={errStyle}>{errors.quantite}</div>}
                </div>
                <div>
                  <label style={labelStyle}>Delai d'expedition</label>
                  <select value={form.delaiExped} onChange={e => upd('delaiExped', e.target.value)} style={inputStyle()}>
                    {['Sous 24h','Sous 48h','Sous 72h','1 semaine'].map(d => <option key={d}>{d}</option>)}
                  </select>
                </div>
                <div style={{ gridColumn: '1/-1' }}>
                  <label style={labelStyle}>Mobile Money ★</label>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '8px' }}>
                    {mobileMoneys.map(mm => (
                      <button key={mm} onClick={() => upd('mobileMoney', mm)} style={{ padding: '10px', border: `1.5px solid ${form.mobileMoney === mm ? '#F5620A' : '#333'}`, borderRadius: '9px', background: form.mobileMoney === mm ? 'rgba(245,98,10,.1)' : '#141414', color: form.mobileMoney === mm ? '#F5620A' : '#888', fontSize: '12px', fontWeight: '700', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                        📱 {mm}
                      </button>
                    ))}
                  </div>
                  {errors.mobileMoney && <div style={errStyle}>{errors.mobileMoney}</div>}
                </div>
              </div>
            </div>
            <div style={cardStyle}>
              <div style={cardTitleStyle}><span>📍</span> Villes de disponibilite ★</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px,1fr))', gap: '8px', marginBottom: '12px' }}>
                {villes.map(v => (
                  <button key={v} onClick={() => toggleVille(v)} style={{ padding: '8px 12px', border: `1.5px solid ${villesSelected.includes(v) ? '#F5620A' : '#333'}`, borderRadius: '8px', fontSize: '12px', fontWeight: '700', cursor: 'pointer', background: villesSelected.includes(v) ? '#F5620A' : '#141414', color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                    {v}
                  </button>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <input value={customVille} onChange={e => setCustomVille(e.target.value)} placeholder="Autre ville..." style={{ ...inputStyle(), flex: 1 }} onKeyDown={e => e.key === 'Enter' && addVille()} />
                <button onClick={addVille} style={{ padding: '11px 16px', background: 'rgba(245,98,10,.15)', border: '1.5px solid #F5620A', borderRadius: '9px', fontSize: '13px', fontWeight: '700', color: '#F5620A', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>+ Ajouter</button>
              </div>
              {errors.villes && <div style={errStyle}>{errors.villes}</div>}
            </div>
          </>
        )}

        {/* ETAPE 5 */}
        {step === 5 && (
          <div style={cardStyle}>
            <div style={cardTitleStyle}><span>📷</span> Photos de la piece</div>
            <div onClick={() => !uploadingPhotos && document.getElementById('photo-input').click()}
              style={{ border: `2px dashed ${uploadingPhotos ? '#F5620A' : '#333'}`, background: '#141414', borderRadius: '12px', padding: '32px', textAlign: 'center', cursor: uploadingPhotos ? 'wait' : 'pointer', marginBottom: '14px' }}>
              <div style={{ fontSize: '32px', marginBottom: '8px' }}>{uploadingPhotos ? '⏳' : '📸'}</div>
              <div style={{ fontSize: '14px', fontWeight: '700', color: uploadingPhotos ? '#F5620A' : '#fff', marginBottom: '4px' }}>
                {uploadingPhotos ? 'Upload en cours...' : 'Cliquez pour ajouter des photos'}
              </div>
              <div style={{ fontSize: '12px', color: '#888' }}>JPG, PNG · Max 8 photos · {photos.length}/8</div>
            </div>
            <input id="photo-input" type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={e => handlePhotos(e.target.files)} />

            {photos.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px,1fr))', gap: '10px', marginBottom: '20px' }}>
                {photos.map((src, i) => (
                  <div key={i} style={{ aspectRatio: '1', borderRadius: '8px', border: '1.5px solid #333', overflow: 'hidden', position: 'relative', background: '#141414' }}>
                    <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    <button onClick={() => {
                      photosRef.current = photosRef.current.filter((_, idx) => idx !== i);
                      setPhotos([...photosRef.current]);
                    }} style={{ position: 'absolute', top: '4px', right: '4px', width: '20px', height: '20px', background: 'rgba(239,68,68,.9)', border: 'none', borderRadius: '50%', cursor: 'pointer', color: '#fff', fontSize: '12px' }}>×</button>
                    {i === 0 && <span style={{ position: 'absolute', bottom: '4px', left: '4px', background: '#F5620A', color: '#fff', fontSize: '9px', fontWeight: '800', padding: '2px 6px', borderRadius: '4px' }}>Principale</span>}
                  </div>
                ))}
              </div>
            )}

            {/* RECAP */}
            <div style={{ background: '#141414', borderRadius: '10px', padding: '16px', marginTop: '10px' }}>
              <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '14px', letterSpacing: '1px', color: '#fff', marginBottom: '10px' }}>RECAPITULATIF</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                {[
                  ['Vehicule', `${form.typeVehicule} · ${form.marqueVehicule} ${form.anneeVehicule}`],
                  ['Piece', `${form.nomPiece} (${form.marquePiece})`],
                  ['Etat', form.etat],
                  ['Garantie', garantieOn ? garantieDuree : 'Non'],
                  ['Prix', form.prix ? `${parseInt(form.prix).toLocaleString('fr-FR')} FCFA` : '—'],
                  ['Villes', villesSelected.join(', ') || '—'],
                  ['Photos', `${photos.length} photo(s)`],
                ].map(([lbl, val], i) => (
                  <div key={i} style={{ background: '#1C1C1C', borderRadius: '7px', padding: '8px 10px' }}>
                    <div style={{ fontSize: '9px', fontWeight: '700', color: '#888', marginBottom: '2px' }}>{lbl.toUpperCase()}</div>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: '#fff' }}>{val || '—'}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* FOOTER STICKY */}
      <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#1C1C1C', borderTop: '1px solid #2A2A2A', padding: '14px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 50 }}>
        <div style={{ fontSize: '12px', color: '#888' }}>
          Etape <span style={{ color: '#F5620A', fontWeight: '800' }}>{step}</span> sur 5
          {photos.length > 0 && <span style={{ marginLeft: '10px', color: '#22C55E', fontWeight: '700' }}>· {photos.length} photo(s) ✓</span>}
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          {step > 1 && (
            <button onClick={prevStep} style={{ padding: '10px 22px', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontWeight: '700', color: '#888', cursor: 'pointer', background: 'transparent', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              ← Retour
            </button>
          )}
          {step < 5 ? (
            <button onClick={nextStep} style={{ padding: '10px 28px', background: '#F5620A', border: 'none', borderRadius: '9px', fontSize: '14px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              Continuer → Etape {step + 1}
            </button>
          ) : (
            <button onClick={publish} disabled={loading || uploadingPhotos} style={{ padding: '10px 28px', background: loading || uploadingPhotos ? '#333' : '#F5620A', border: 'none', borderRadius: '9px', fontSize: '14px', fontWeight: '800', color: '#fff', cursor: loading || uploadingPhotos ? 'not-allowed' : 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
              {loading ? '⏳ Publication...' : uploadingPhotos ? '⏳ Upload photos...' : '🚀 Publier l\'annonce'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AnnoncePage;